// extracted by mini-css-extract-plugin
export default {"reportHeader":"ReportHeader_reportHeader__1BWqT","cardWrapper":"ReportHeader_cardWrapper__e5c7y"};